import styled from 'styled-components';

// consts
import { UserInfoWidth } from 'defs/Constans'

export const Main = styled.main`
  display: flex;
  /* grid-template-columns: 6.8rem 1fr; */
  height: 100vh;
`;

export const Content = styled.div`
  margin-left: ${(props) => props.theme.consts.navBar};
  width: 100%;
  transition: .3s;

  display: grid;
  grid-template-columns: 1fr 0rem;

  &.chatOpen {
    grid-template-columns: 1fr ${UserInfoWidth};
  }
`;